import { createSelector } from "reselect";

const selectNotificationCampaignsState = (state) => state.notificationCampaigns;

const selectNotificationCampaigns = () =>
  createSelector(
    selectNotificationCampaignsState,
    (notificationCampaignsState) => notificationCampaignsState.notificationCampaigns
  );

const selectNotificationCampaignToEdit = () =>
  createSelector(
    selectNotificationCampaignsState,
    (notificationCampaignsState) => notificationCampaignsState.notificationCampaignToEdit
  );

export { selectNotificationCampaignToEdit, selectNotificationCampaigns };
